import Menu from 'material-ui/Menu/Menu';
import MenuItem from 'material-ui/Menu/MenuItem';
import MenuList from 'material-ui/Menu/MenuList';

export { MenuItem, MenuList };
export default Menu;


// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/components/Menu/index.ts